import {
  addFuelSupplyDetailsAPI,
  deleteFuelSupplyDetailsAPI,
  getFuelSupplyDetailsAPI,
  generateFuelSupplyRequestAPI,
  updateFuelSupplyDetailsAPI,
  updateFuelSupplyRequestAPI,
} from "./api";

export const addFuelSupplyDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addFuelSupplyDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const generateFuelSupplyRequest = (params, data) => {
  return new Promise((resolve, reject) => {
    generateFuelSupplyRequestAPI(params, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateFuelSupplyRequest = (params, data) => {
  return new Promise((resolve, reject) => {
    updateFuelSupplyRequestAPI(params, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateFuelSupplyDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateFuelSupplyDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getFuelSupplyDetails = (data) => {
  return new Promise((resolve, reject) => {
    getFuelSupplyDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteFuelSupplyDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteFuelSupplyDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};